import ReactGA from "react-ga4";

// Flag to check if GA should be initialized
const isGAEnabled = process.env.REACT_APP_GA_ENABLED === "true";

export const initializeGA = (measurementId: string) => {
  if (isGAEnabled) {
    ReactGA.initialize(measurementId);
  } else {
    console.log("Google Analytics disabled in this environment");
  }
};

export const logPageView = () => {
  if (isGAEnabled) {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname + window.location.search,
    });
  }
};

export const logEvent = (
  category: string,
  action: string,
  label?: string,
  value?: number
) => {
  if (isGAEnabled) {
    ReactGA.event({
      category,
      action,
      label,
      value,
    });
  }
};
